/**
 * @generated SignedSource<<fb1e0d3a42a27cb2491db31fd6656755>>
 * @relayHash 374078a9000b0436a9cb061d74172f2b
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/559.0.0-2026-05-12T16:23:21.933Z/PhotosSearchBrowseQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseQuery$variables = {
  creator?: ReadonlyArray<string> | null;
  first?: number | null;
  page?: number | null;
  project?: ReadonlyArray<string> | null;
  room?: ReadonlyArray<string> | null;
  searchTerm?: string | null;
  style?: ReadonlyArray<string> | null;
};
export type PhotosSearchBrowseQuery$data = {
  readonly viewer: {
    readonly photosSearchBrowseQuery: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly path: string | null;
        } | null;
      } | null> | null;
      readonly totalResults: number | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseWrapper_viewer">;
  };
};
export type PhotosSearchBrowseQuery = {
  response: PhotosSearchBrowseQuery$data;
  variables: PhotosSearchBrowseQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "creator"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "project"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "room"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "style"
},
v7 = [
  {
    "kind": "Variable",
    "name": "creator",
    "variableName": "creator"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  },
  {
    "kind": "Variable",
    "name": "project",
    "variableName": "project"
  },
  {
    "kind": "Variable",
    "name": "room",
    "variableName": "room"
  },
  {
    "kind": "Variable",
    "name": "searchTerm",
    "variableName": "searchTerm"
  },
  {
    "kind": "Variable",
    "name": "style",
    "variableName": "style"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  },
  (v11/*: any*/),
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PhotosSearchBrowseQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "PhotosSearchBrowseQueryConnection",
            "kind": "LinkedField",
            "name": "photosSearchBrowseQuery",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PhotosSearchBrowseQueryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhotosSearchBrowsePhoto",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PhotosSearchBrowseWrapper_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PhotosSearchBrowseQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "PhotosSearchBrowseQueryConnection",
            "kind": "LinkedField",
            "name": "photosSearchBrowseQuery",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PhotosSearchBrowseQueryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhotosSearchBrowsePhoto",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "caption",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradePhotoStyle",
                        "kind": "LinkedField",
                        "name": "styles",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradePhotoStyle",
                        "kind": "LinkedField",
                        "name": "room",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v13/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DesignFirm",
                        "kind": "LinkedField",
                        "name": "designFirm",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "designProject",
                            "kind": "LinkedField",
                            "name": "designProjects",
                            "plural": true,
                            "selections": [
                              (v11/*: any*/),
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v14/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PhotosSearchBrowsePhotoProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "projectTypes",
                            "storageKey": null
                          },
                          (v11/*: any*/),
                          (v10/*: any*/),
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "width",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "height",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PhotoLike",
                        "kind": "LinkedField",
                        "name": "photoLike",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalPhotoLikes",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PhotosSearchBrowseFacets",
                "kind": "LinkedField",
                "name": "facets",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacetValueType",
                    "kind": "LinkedField",
                    "name": "imageStyleFacet",
                    "plural": true,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacetValueType",
                    "kind": "LinkedField",
                    "name": "imageRoomTypeFacet",
                    "plural": true,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacetValueType",
                    "kind": "LinkedField",
                    "name": "designProjectTypeFacet",
                    "plural": true,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FacetValueType",
                    "kind": "LinkedField",
                    "name": "imageCreatorFacets",
                    "plural": true,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfPages",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "hiddenPhotoSearchBrowseFreetextSearch",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "hiddenPhotoSearchBrowseFreetextSearch"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"hiddenPhotoSearchBrowseFreetextSearch\")"
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-trade/559.0.0-2026-05-12T16:23:21.933Z/PhotosSearchBrowseQuery",
    "metadata": {},
    "name": "PhotosSearchBrowseQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8eec53a4827ed2faf40fef267aabfede";

export default node;
